// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import LazyloadIframeController from "./lazyload_iframe_controller"
application.register("lazyload-iframe", LazyloadIframeController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
